const state = {
  user: {},
  billingAccounts: [],
  portalInfo: null,
  appVersion: process.package.VERSION || '0.0.0'
};

export default state;
